import React from "react";

import Chart, {
  ArgumentAxis,
  CommonSeriesSettings,
  Legend,
  Series,
  Tooltip,
  ValueAxis,
  Label,
} from "devextreme-react/chart";
import { useTranslation } from "react-i18next";

const ProductBurndown = (props) => {
  const [t,i18n] =useTranslation("planning")

  return (
    <Chart
      dataSource={props.data}
      style={{ height: "338px" }}
    >
      <CommonSeriesSettings argumentField="sprint" />
      <Series
        name={t("hvagile_chartburndown_conventionts_expected")}
        valueField="ptsRemaining"
        axis="points"
        type="line"
        color="#29b9d0"
        barPadding={0.6}
      />
      <Series
        name={t("hvagile_chartburndown_conventionts_remaining")}
        valueField="velocity"
        axis="points"
        type="line"
        color="#6ab41b"
      />

      <ArgumentAxis>
        <Label overlappingBehavior="stagger" />
        {/* <Grid visible={true}/> */}
      </ArgumentAxis>

      <ValueAxis name="points" position="left" tickInterval={30} />
      <Tooltip
        enabled={true}
        shared={true}
      />

      <Legend verticalAlignment="bottom" horizontalAlignment="center" visible={true} />
    </Chart>
  );
};

export default ProductBurndown;
